import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentQuotationTask } from '@/providers/QuotationTaskProvider';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { QuotationTaskFileEditForm } from '@/components/features/tasks/quotation/[quotation_task_id]/QuotationTaskFileEditForm';

export const ApprovalQuotationTaskFiles = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle(`Approval - Files`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `承認待ち一覧`, path: `/w/${_w_!.identifier}/approval` },
        {
          label: `承認待ち一覧 - 申請タスク（見積）詳細`,
          path: `/w/${_w_!.identifier}/approval/teams/${_t_!.id}/sales_orders/${_so_!.id}/quotation_tasks/${task!.id}`,
        },
      ]),
    []
  );

  const { _so_ } = useCurrentSalesOrder();
  const { quotationTask: task } = useCurrentQuotationTask();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <QuotationTaskFileEditForm />
    </WorkspaceLayout>
  );
};
